import React, { useEffect, useState } from "react";
import Select from "react-select";

const Offerenlinea = () => {
  const [carreras, setCarreras] = useState([]);
  const [loading, setLoading] = useState(true);
  const [facultad, setFacultad] = useState({
    value: "todos",
    label: "Toda la oferta",
  });

  useEffect(() => {
    fetch("https://utpl.edu.ec/carreras/servicios/carreras-en-linea.json")
      .then((response) => response.json())
      .then((data) => {
        setCarreras(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error al cargar las carreras:", error);
        setLoading(false);
      });
  }, []);

  const renderHTML = (htmlString) => (
    <span dangerouslySetInnerHTML={{ __html: htmlString }} />
  );

  const optionsFacultad = [
    { value: "todos", label: "Toda la oferta" },
    {
      value: "Ciencias Económicas y Empresariales",
      label: "Ciencias Económicas y Empresariales",
    },
    {
      value: "Ciencias Exactas y Naturales",
      label: "Ciencias Exactas y Naturales",
    },
     {
      value: "Ciencias del Comportamiento",
      label: "Ciencias del Comportamiento",
    },
    {
      value: "Ciencias Sociales, Educación y Humanidades",
      label: "Ciencias Sociales, Educación y Humanidades",
    },
    {
      value: "Ciencias Jurídicas y Políticas",
      label: "Ciencias Jurídicas y Políticas",
    },
    {
      value: "Ingenierías y Arquitectura",
      label: "Ingenierías y Arquitectura",
    },
  ];

  const handleChangeFacultad = (selected) => {
    setFacultad(selected);
  };

  // Filtrado por facultad
  const carrerasFiltradas =
    facultad && facultad.value !== "todos"
      ? carreras.filter((carrera) =>
          carrera.field_area
            .toLowerCase()
            .includes(facultad.value.toLowerCase()),
        )
      : carreras;

  if (loading) {
    return <p className="text-center py-10">Cargando...</p>;
  }

  return (
    <div>
      <div className="bloque1 flex-center new-offer ">
        <div>
          <p>
            <b>Facultad </b>
          </p>
          <Select
            options={optionsFacultad}
            defaultValue={optionsFacultad[0]}
            onChange={handleChangeFacultad}
          />
        </div>
      </div>

      <div className="bloque2 margin">
        <div className="wrapper-academicoffer ">
          {carrerasFiltradas.map((carrera, index) => (
            <div key={index}>
              <div className="programa-imagen ">
                <img src={carrera.field_imagen_principal} alt={carrera.title} />
              </div>

              <div className="layout8">
                {carrera.field_tag?.[0] && (
                  <p className="tag-cupos">{carrera.field_tag}</p>
                )}
                <h3>{renderHTML(carrera.title)}</h3>
                <p>
                  <strong>Facultad:</strong> {carrera.field_area.trim()}
                </p>
                <p>
                  <strong>Duración:</strong>{" "}
                  {carrera.field_carrera_duracion.trim()}
                </p>

                <div className="wrapper-link">
                  <a
                    className="link-offer "
                    href={carrera.path}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Ver programa
                    <span className="material-icons text-sm">
                      arrow_forward_ios
                    </span>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Offerenlinea;
